import type { ChannelCatalogItem, ConnectionHubCloseReason, SetupResponse } from "../../../api/connectionHub.types";
import { CONNECTION_HUB_CLOSE_REASON } from "../../../api/connectionHub.types";
import DelegatedInboxCard from "../../accounts/DelegatedInboxCard/DelegatedInboxCard";
import ConnectModalShell from "../ConnectModalShell/ConnectModalShell";
import styles from "./DelegatedViewStep.module.scss";

export interface DelegatedViewStepProps {
  visible: boolean;
  setup: SetupResponse;
  channels?: ChannelCatalogItem[];
  agencyClientId: number | null;
  onClose: (reason: ConnectionHubCloseReason) => void;
}

const DelegatedViewStep = ({ visible, setup, channels, agencyClientId, onClose }: DelegatedViewStepProps): JSX.Element => (
  <ConnectModalShell
    visible={visible}
    title="Finish Setup"
    bodyClassName={styles.modalBody}
    primaryLabel="Done"
    onPrimary={() => onClose(CONNECTION_HUB_CLOSE_REASON.PROGRAMMATIC)}
    onClose={() => onClose(CONNECTION_HUB_CLOSE_REASON.CLOSE_BUTTON)}
    onDismiss={(reason) => onClose(reason === "escape" ? CONNECTION_HUB_CLOSE_REASON.ESCAPE : CONNECTION_HUB_CLOSE_REASON.BACKDROP)}
  >
    <section className={styles.list} aria-label="Delegated inbox connections">
      {setup.inboxes.map((group) => (
        <DelegatedInboxCard key={group.inbox.id} group={group} channels={channels} agencyClientId={agencyClientId} />
      ))}
    </section>
  </ConnectModalShell>
);

export default DelegatedViewStep;
